wbApp.controller('OnlinePaymentConfigurationDetailCtrl', ['$scope', 'onlinePaymentConfigurationSvc',
function ($scope, onlinePaymentConfigurationSvc) {

    $scope.modelOrig = angular.copy($scope.model);

    $scope.detailIsUnchanged = function (data) {
        return angular.equals(data, $scope.modelOrig);
    };

    $scope.isSaving = false;

    $scope.onDetailSave = function (model) {

        $scope.isSaving = true;

        switch (model.providerType) {
            case 0:
                model.secret.merchantId = null;
                model.secret.merchantPassword = null;
                break;
            case 1:
                model.secret.clientCertificateBase64 = null;
                break;
            case 2:
                model.secret.merchantPassword = null;
                break;
        }

        if (!model.id) {
            onlinePaymentConfigurationSvc.insert(model).$promise.then(success, error);
        } else {
            onlinePaymentConfigurationSvc.update(model).$promise.then(success, error);
        }

        function success() {
            $scope.isSaving = false;
            if ($scope.onSave) {
                $scope.onSave();
            }
            $scope.$hide();
        }

        function error(data) {
            $scope.isSaving = false;
            $scope.detailError = data;
        }
    }
}]);
